"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const theme_1 = require("@atlaskit/theme");
const styled_components_1 = __importDefault(require("styled-components"));
const chevron_down_1 = __importDefault(require("@atlaskit/icon/glyph/chevron-down"));
const chevron_up_1 = __importDefault(require("@atlaskit/icon/glyph/chevron-up"));
const colors = __importStar(require("@atlaskit/theme/colors"));
class ExpandablePanel extends React.Component {
    constructor(props) {
        super(props);
        this.togglePanel = () => {
            this.props.onToggle(this.props.title);
        };
    }
    render() {
        const { children, title, isCollapsed, overflow } = this.props;
        return (React.createElement(Wrapper, { collapsed: isCollapsed },
            React.createElement(Header, { className: "header", onClick: this.togglePanel },
                typeof this.props.title === "string" ? (React.createElement(HeaderTitle, { className: "header-title" }, title)) : (this.props.title),
                React.createElement(HeaderActions, null, isCollapsed ? (React.createElement(chevron_down_1.default, { label: "closed", size: "large" })) : (React.createElement(chevron_up_1.default, { label: "open", size: "large" })))),
            React.createElement(Content, { className: "content", overflow: overflow, collapsed: isCollapsed }, !isCollapsed ? children : null)));
    }
}
exports.ExpandablePanel = ExpandablePanel;
const wrapper = styled_components_1.default.div;
const Wrapper = wrapper `
  margin: 0 0 20px 0;
  padding: 0 10px 10px;
  border-radius: 5px;
  background-color: ${theme_1.themed({ light: colors.N30, dark: colors.DN60 })};
  padding-bottom: ${({ collapsed }) => (collapsed ? 0 : "auto")};
`;
const Header = styled_components_1.default.header `
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;
const HeaderTitle = styled_components_1.default.div `
  display: flex;
  font-size: 18px;
  font-weight: 500;
`;
const HeaderActions = styled_components_1.default.div `
  display: flex;
`;
const content = styled_components_1.default.div;
const Content = content `
  display: flex;
  flex-direction: column;
  overflow: ${({ overflow }) => (overflow ? overflow : `hidden;`)}

  ${({ collapsed, theme }) => !collapsed
    ? `
    background-color: ${theme_1.themed({ light: colors.N0, dark: colors.DN40 })({
        theme
    })};
    border-radius: 3px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  `
    : ""}

  ${({ collapsed }) => (collapsed ? "height: 0;" : "")}
`;
